export default __webpack_public_path__ + "static/media/ideas_6.c16ab2b4.png";